import React from "react";
import {
  Pencil, PencilBox,
  ArrowL, ArrowD, ArrowR,
  ChevronR, ChevronD,
  ThreeDotsV
} from "../../components/Icons";
import { colors, gStyle, CardContainer } from "../../components";

export default function IconExamples() {
  const onClick = () => console.log('clicked...');
  const styles = {
    btn: { cursor: "pointer" }
  }
  return (
    <CardContainer>
      <p style={gStyle.text}>
        Text 텍스트&nbsp;
        <ArrowL onClick={onClick} />
        <ArrowR onClick={onClick} />
        <ArrowD onClick={onClick} />
      </p>
      <h3 style={gStyle.title}>
        SUBTITLE 서브타이틀&nbsp;
        <Pencil onClick={onClick} style={styles.btn} />

        <Pencil style={styles.btn} onClick={onClick} />

        <PencilBox onClick={onClick} style={styles.btn} />

        <ArrowL onClick={onClick} />
        <ArrowR onClick={onClick} />
        <ArrowD onClick={onClick} />

        <ChevronR onClick={onClick} style={styles.btn} />
        <ChevronD onClick={onClick} />

        <ThreeDotsV
          onClick={onClick}
          style={{ color: colors.danger, fontSize: "24px" }}
        />
      </h3>
    </CardContainer>
  )

}